import React from 'react';
import { Popover, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { InfoWraper } from './style';
import { logOut } from '../../../redux/authentication/actionCreator';

const { Text } = Typography;

function AuthInfo() {
    const dispatch = useDispatch();
    const history = useNavigate();
    const userDetails = useSelector((state) => state.auth.loginData);
    const displayName = userDetails?.name || '';
    const firstName = displayName ? displayName.toUpperCase().split(' ')[0] : '';
    const userRole = userDetails?.loginType || userDetails?.group || 'Customer Care';

    const SignOut = (event) => {
        event.preventDefault();
        dispatch(logOut());
        setTimeout(() => {
            history('/login', { replace: true });
        }, 100);
    };

    const userContent = (
        <div style={{ width: '180px', padding: '4px' }}>
            <div style={{ padding: '8px 12px', borderBottom: '1px solid #f0f0f0', marginBottom: '8px' }}>
                <Text strong style={{ display: 'block', fontSize: '14px' }}>{displayName.toUpperCase()}</Text>
                <Text type="secondary" style={{ fontSize: '11px', display: 'block', wordBreak: 'break-all' }}>{userDetails?.email || ''}</Text>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Link 
                    to="#" 
                    style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '8px', 
                        padding: '8px 12px', 
                        color: '#262626', 
                        borderRadius: '4px',
                        textDecoration: 'none',
                        fontSize: '13px'
                    }}
                >
                    <FeatherIcon icon="lock" size={14} />
                    <span>Change Password</span>
                </Link>
                <Link 
                    to="#" 
                    onClick={SignOut}
                    style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '8px', 
                        padding: '8px 12px', 
                        color: '#ff4d4f', 
                        borderRadius: '4px',
                        textDecoration: 'none',
                        fontSize: '13px'
                    }}
                >
                    <FeatherIcon icon="log-out" size={14} />
                    <span>Sign Out</span>
                </Link>
            </div>
        </div>
    );

    return (
        <InfoWraper>
            <div className="nav-author" style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'flex-end', marginRight: 12 }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: 1.1 }}>
                    <Text style={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>{firstName}</Text>
                    {/* <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px' }}>{userRole}</Text> */}
                </div>
                <Popover placement="bottomRight" content={userContent} trigger="click">
                    <Link to="#" style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            background: 'rgba(255, 255, 255, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid rgba(255, 255, 255, 0.25)',
                            cursor: 'pointer',
                            transition: 'background 0.3s ease'
                        }}>
                            <FeatherIcon icon="user" size={18} style={{ color: '#fff' }} />
                        </div>
                    </Link>
                </Popover>
            </div>
        </InfoWraper>
    );
}

export default AuthInfo;
